import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';

import { BetslipType } from '../../../../../core/betslip-type';
import { isBetBuilderPick } from '../../../../../core/utils';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { isBetBuilderExclusiveToken } from '../../reward-tokens.utils';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class BetBuilderValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.BetBuilder;

    constructor() {
        super();
    }

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const picks = state.selectedPicks;

        const betbuilderPicks = picks.filter((pick) => isBetBuilderPick(pick));

        // if we dont have bet builder picks and token is only for bet builder, return false.
        if (betbuilderPicks.length === 0) {
            return !token.isBetBuilder || !isBetBuilderExclusiveToken(token);
        }

        // if we have bet builder picks and token is for bet builder, return true.
        if (token.isBetBuilder) {
            return true;
        }

        // if we have single bet builder and token is not for bet builder, return false.
        const isSingleBetbuilder = (picks.length === betbuilderPicks.length && picks.length === 1) || state.selectedType === BetslipType.BetBuilder;

        if (isSingleBetbuilder) {
            return false;
        }

        //if we have bet builder picks and combo is allowed, return true.
        return token.filter.betSlipType?.toString() === BetSlipType.Combo || !!token.isSingleAndComboSelected;
    }
}
